<template>
  <div :class="inputClass">
    <label :for="name" class="">
      {{ text }}
      <span v-if="required" class="text-red font-bold"> * </span>
    </label>
    <Field
      as="textarea"
      :id="id"
      class="inputForm"
      :name="name"
      :type="type"
      :rules="rules"
      :value="disabled || fill ? old : ''"
      :placeholder="placeholder ? placeholder : text"
      :disabled="disabled"
    />
    <div>
      <ErrorMessage class="errorForm" :name="name" />
    </div>
    <div>
      <span class="errorForm" v-if="errors && errors[name] && errors[name][0]">{{ errors[name][0] }}</span>
    </div>
  </div>
</template>

<script>
import { Field, ErrorMessage } from 'vee-validate'
export default {
  components: {
    Field,
    ErrorMessage
  },
  data: () => ({}),
  props: {
    text: String,
    id: String,
    inputClass: String,
    name: String,
    type: String,
    required: Boolean,
    placeholder: String,
    rules: String,
    old : [String, Number],
    disabled: Boolean,
    fill : Boolean,
    errors: [Array, Object]
  },
  created() {
  }
}
</script>
